import React from "react";
import "./diamondShape.scss";

const DimaondShape = (props) => {
  return (
    <>
      <div className="diamondShapeWrapper">
        <div className="diamondContainer1">
          <p className="diamondNum">{props.diamondnum}</p>
          <p className="d-heading">{props.diamondhead}</p>
          <p className="plain-text">
          {props. diamondPara}
          </p>
        </div>
      </div>
    </>
  );
};

export default DimaondShape;
